class DeleteBeneficiaryContact {
	constructor(
		public readonly facilityId: number,
		public readonly beneficiaryId: number,
		public readonly contactId: number,
	) {
		Object.freeze(this);
	}
}

export default DeleteBeneficiaryContact;
